export enum OrderLogType {
    ChangeTypeOfPrescriptionToNonPrescription = 1,
    ChangeTypeOfNonPrescriptionToPrescription = 2,
    UpdateOrderStateInBatch = 3,
    UpdatePrescriptionStateInBatch = 4,
    AssemblyOperation = 5,

    AssemblerReceivedConfirmedByUser = 14,
    AssemblyStartConfirmedByUser = 15,
    AssemblyEndConfirmedByUser = 16,
    SentToStoreConfirmedByUser = 17
}